import React from "react";
import SheetWrapper from "./components/SheetWrapper";
import SheetBody from "./components/SheetBody";
import SheetFooter from "./components/SheetFooter";
import { useBreakpoint } from "@/hooks/useViewport";

interface ViewAndEditRightSideSheetProps {
  trigger?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  open: boolean;
  handleClose: any;
  /** Static override; bypasses responsive widths when provided. */
  width?: string;
  showCloseButton?: boolean;
  noScroll?: boolean;
}

const RESPONSIVE_WIDTH: Record<
  "mobile" | "tablet" | "tablet-lg" | "desktop",
  string
> = {
  mobile: "100vw",
  tablet: "70vw",
  "tablet-lg": "55vw",
  desktop: "40vw",
};

export default function ViewAndEditRightSideSheet({
  trigger,
  children,
  actions,
  handleClose,
  open,
  width,
  showCloseButton = false,
  noScroll = false,
}: ViewAndEditRightSideSheetProps) {
  const breakpoint = useBreakpoint();
  const resolvedWidth = width ?? RESPONSIVE_WIDTH[breakpoint];

  return (
    <>
      {trigger && trigger}
      <SheetWrapper
        open={open}
        handleClose={handleClose}
        width={resolvedWidth}
        showCloseButton={showCloseButton}
      >
        <SheetBody noScroll={noScroll}>{children}</SheetBody>
        {actions && <SheetFooter>{actions}</SheetFooter>}
      </SheetWrapper>
    </>
  );
}
